// _book-binding.js — which side a book is bound on (ASK-139 F-139aj).
//
// The feed row says `binding: "left" | "right"` (GCG; default "left", `fieldSources.binding` names who
// said so). Left is the Western book: spine on the left when the front cover faces you. Right is the
// manga / right-to-left book: spine on the right. There is no third value — the digital analogues are
// EPUB `page-progression-direction: rtl` and ComicInfo `Manga=YesAndRightToLeft`, both two-state — so
// anything that is not the word "right" is left, exactly as a row that never heard of the field.
//
// Eager and tiny: the normaliser stamps it on every line and the shelf seat reads it. The mirror that
// turns a left-bound asset into the right-bound one is the lazy half (`_book-mirror.js`).

export function bookBinding(product) {
	return product?.binding === "right" ? "right" : "left";
}
